module.exports = __webpack_public_path__ + "static/iQuestLogo-665414e5b2517c60df23c43ca7f4c7e2.png";